import React from 'react'
import { connect } from 'react-redux'
import ImageLoader from 'alt-imageloader'
import Button from '../components/Button.jsx'
import AnimatedTitle from '../components/AnimatedTItle.jsx'
import scrollTo from '../utils/scrollTo'

const LandingContainer = props => (
    <div className="landing-container">
        <div className="landing-background">
            <ImageLoader
                background="/images/bck/bed_landing.jpg"
                animationDelay={200}
            />
        </div>
        <div className="landing-inner">
            <AnimatedTitle
                titleArray={[
                    props.langData.landing.title,
                    props.langData.landing.title2,
                    props.langData.landing.title3
                ]}
            />
            <p className="paragraph landing-text">
                {props.langData.landing.text}
            </p>
            <div className="landing-button-container">
                <Button
                    text={props.langData.landing.button}
                    link="/onama"
                    type="white"
                />
            </div>
        </div>

        <div className="social-icons hidden-xs">
            <div className="social-item">
                <a
                    href="https://web.facebook.com/BedrinaProjekt/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        className="social-item__img"
                        src="/images/ico/bed_facebook.png"
                    />
                </a>
            </div>
            <div className="social-item">
                <a
                    href="https://www.instagram.com/gbedrina/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        className="social-item__img"
                        src="/images/ico/bed_instagram.png"
                    />
                </a>
            </div>
            <div className="social-item">
                <a
                    href="https://linkedin.com/in/goran-bedrina-30a36345"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        className="social-item__img"
                        src="/images/ico/bed_linkedin.png"
                    />
                </a>
            </div>
        </div>

        <div
            className="icon-scroll hidden-sm hidden-xs"
            onClick={scrollTo.bind(null, 'services-id')}
        >
        </div>
    </div>
)

const mapStateToProps = state => ({
    langData: state.langData
})

export default connect(mapStateToProps)(LandingContainer)



// WEBPACK FOOTER //
// ./src/scripts/containers/LandingContainer.jsx